import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
export var displayName = 'textArea';
export var defaultProps = {
  'data-id': displayName,
  disabled: false,
  helpText: '',
  label: '',
  maxLength: 524288,
  maxLengthExcludeChars: [],
  name: '',
  onBlur: function onBlur(event) {
    return event;
  },
  onChange: function onChange(event) {
    return event;
  },
  onFocus: function onFocus(event) {
    return event;
  },
  renderOverlay: function renderOverlay() {
    return null;
  },
  transform: function transform(value) {
    return value;
  },
  showCharacterCount: false,
  spinner: false,
  skinType: 'textArea',
  tabIndex: undefined,
  touched: null,
  width: '100%',
  height: '300px',
  value: ''
};
export var initialState = function initialState(props) {
  return _Object$assign({}, getCurrentLength(props.value, props.maxLengthExcludeChars));
};
export var getCurrentLength = function getCurrentLength(value, maxLengthExcludeChars) {
  var currentLength = maxLengthExcludeChars.reduce(function (accValue, currentValue) {
    return accValue.replace(new RegExp(currentValue, 'g'), '');
  }, value).length;
  return {
    currentLength: currentLength
  };
};